import { useEffect, useRef } from 'react';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

import { useFindStatisticsData } from '../useFindStatisticsData.hook';
import { useFindStatisticsOrder } from '../useFindStatisticsOrder.hook';

const HiddenCSVLink = styled(CSVLink)`
   visibility: hidden;
`;

type CSVDownloadButtonProps = {
   readonly statisticsId: number;
   readonly downloading: boolean;
   readonly onDownloaded: VoidFunction;
};

export const CSVDownloader = (props: CSVDownloadButtonProps): JSX.Element | null => {
   const { downloading, onDownloaded } = props;
   const { data: statisticsData, loading: statisticsDataLoading } = useFindStatisticsData(props.statisticsId);
   const { data: statisticsOrder, loading: statisticsOrderLoading } = useFindStatisticsOrder(props.statisticsId);

   const csvLink = useRef<CSVLink>(null);

   useEffect(() => {
      if (!downloading || statisticsDataLoading || statisticsOrderLoading) {
         return;
      }

      // there is no proper TS mapping and for CSVDownload component filenames are not working
      (csvLink.current as any)?.link.click();

      onDownloaded();
   }, [downloading, statisticsDataLoading, statisticsOrderLoading, onDownloaded]);

   if (!downloading || statisticsDataLoading || statisticsOrderLoading || !statisticsOrder || !statisticsData) {
      return null;
   }

   const { range } = statisticsOrder;
   const lowerBound = range.hasLowerBound() ? range.lowerEndpoint() : '';
   const upperBound = range.hasUpperBound() ? range.upperEndpoint() : '';
   const filename = `${statisticsOrder.name}_${lowerBound}-${upperBound}_${statisticsOrder.created}.csv`;

   const headers = statisticsData.headers.map((header) => header.name);
   const rows = statisticsData.rows.map((row) => row.cells);
   const headersAndRows = [headers].concat(rows);

   return <HiddenCSVLink filename={filename} data={headersAndRows} ref={csvLink} />;
};
